export {
  DEFAULT_ACTIVE_SHOP_LOCALES,
  DEFAULT_SHOP_LOCALE,
  SHOP_LOCALE_COOKIE,
  type LocaleResolutionOptions,
  type ShopLanguage,
  type ShopLocale,
} from './shop-locale/shared'
export {
  languageToLocale,
  localeToLanguage,
  localeToPathSegment,
  normalizeActiveShopLocales,
  normalizeShopLocale,
} from './shop-locale/normalization'
export { inferLocaleFromPathname, stripLocalePrefix, withLocalePrefix } from './shop-locale/path'
export { readLocaleFromCookieHeader, readLocaleFromDocumentCookie, writeLocaleCookie } from './shop-locale/cookies'
export { resolveLocaleFromAcceptLanguage, resolveShopLocale } from './shop-locale/resolution'
